<template>
    <activation-preview-provider
        v-slot="{
            brief,
            activationFields,
            step
        }"
        :module-name="moduleName"
    >
        <activation-personal-info-view
            v-if="brief"
            :brief="brief"
            :brief-fields="activationFields"
            :is-preview="true"
            :step="step"
        />
        <g-loader v-else type="fixed" />
    </activation-preview-provider>
</template>

<script>
    import ActivationPreviewProvider from '../../providers/preview-providers/ActivationPreviewProvider';
    import ActivationPersonalInfoView from '../../data-views/activation-briefs/ActivationBriefPersonalInfoView';
    import PageMask from '../../library/PageMask';
    import {NAME_PERSONAL_INFO} from '../../../constants/activation-brief-steps';

    export default {
        name:       'ActivationInfoPreviewView',
        components: {
            ActivationPreviewProvider,
            ActivationPersonalInfoView,
            PageMask,
        },
        data(){
            return {
                moduleName: NAME_PERSONAL_INFO,
            };
        },
    };
</script>
